export const DEFAULT_BORDER_LINK = 'solid';
export const DEFAULT_BORDER_PSEUDO = 'dashed';
export const BORDERS = ['solid', 'dashed', 'hidden'] as const;

export const DEFAULT_KIND = 'common';
export const KINDS = ['common', 'caption', 'primary'] as const;

export const DEFAULT_THEME = 'white';
export const THEMES = ['white', 'blue', 'grey'] as const;
